export default __webpack_public_path__ + "static/search-hero-bg-97dd163e1454198e57254525529aeb79.svg";